import React from "react";
import { resetMasterProfileForm } from "../../../../../redux/reducers/resources/master/profile/form";
import { resetMasterProfileList } from "../../../../../redux/reducers/resources/master/profile/list";
import { store } from "../../../../../redux/store";
import { heights } from "../../../../../styles/romeu/heights";
import { widths } from "../../../../../styles/romeu/widths";
import { MasterProfileFormController } from "./controller/controller";
import { MasterProfileList } from "./list/list";
import { setOrganismProfile } from "../../../../../redux/reducers/catalog/catalog";

export class MasterProfilesContainer extends React.Component {
    componentWillUnmount(): void {
        store.dispatch(resetMasterProfileForm());
        store.dispatch(resetMasterProfileList());
        store.dispatch(setOrganismProfile(undefined));
        
    }

    render(): React.ReactNode {
        return (
            <>
                <MasterProfileList
                    widthPopUp={widths.master.default}
                    heigthPopUp={heights.master.default}
                />
                <MasterProfileFormController
                    widthPopUp={widths.master.default}
                    heigthPopUp={heights.master.default}
                />
            </>
        );
    }
}
